import servicesUtils from "../../../utils/servicesUtils";

interface PayloadError {
  kind: "err";
  err_code: "not_synced";
}

export interface PayloadSuccess {
  kind: "success";
  last_synced_at: string;
  workspace_name: string;
  file_sync_enabled?: boolean;
}

export interface SyncStatus {
  id: number;
  name: string;
  payload: PayloadError | PayloadSuccess;
}

export interface SyncStatusResponse {
  [key: string]: SyncStatus;
}

const getCloudSyncStatus = () => {
  return new Promise<SyncStatusResponse>((resolve, reject) => {
    servicesUtils
      .getService<SyncStatusResponse>("/qsync/last_synced/")
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getCloudSyncStatus;
